"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _reactRedux = require("react-redux");

var _Auth = require("../selectors/Auth");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedReactMessage = _interopRequireDefault(require("I18n/components/FormattedReactMessage"));

var _FormattedDateTime = _interopRequireDefault(require("I18n/components/FormattedDateTime"));

var _UIAlert = _interopRequireDefault(require("UIComponents/alert/UIAlert"));

function getI18nKey(suffix) {
  return "FileManagerCore.shutterstockMaintenanceAlert." + suffix;
}

var ShutterstockMaintenanceAlert = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ShutterstockMaintenanceAlert, _Component);

  function ShutterstockMaintenanceAlert() {
    (0, _classCallCheck2.default)(this, ShutterstockMaintenanceAlert);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(ShutterstockMaintenanceAlert).apply(this, arguments));
  }

  (0, _createClass2.default)(ShutterstockMaintenanceAlert, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          isUngatedForShutterstockMaintenance = _this$props.isUngatedForShutterstockMaintenance,
          className = _this$props.className,
          useShortVersion = _this$props.useShortVersion;

      if (isUngatedForShutterstockMaintenance) {
        return _react.default.createElement(_UIAlert.default, {
          titleText: _react.default.createElement(_FormattedMessage.default, {
            message: getI18nKey('title')
          }),
          type: "warning",
          className: className
        }, _react.default.createElement(_FormattedReactMessage.default, {
          message: useShortVersion ? getI18nKey('shortContent') : getI18nKey('content'),
          options: {
            date: _react.default.createElement(_FormattedDateTime.default, {
              value: 1589587200000,
              format: "LLLL"
            })
          }
        }));
      }

      return null;
    }
  }]);
  return ShutterstockMaintenanceAlert;
}(_react.Component);

ShutterstockMaintenanceAlert.propTypes = {
  className: _propTypes.default.string,
  useShortVersion: _propTypes.default.bool,
  isUngatedForShutterstockMaintenance: _propTypes.default.bool.isRequired
};
ShutterstockMaintenanceAlert.defaultProps = {
  useShortVersion: false
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    isUngatedForShutterstockMaintenance: (0, _Auth.getIsUngatedForShutterstockMaintenance)(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(ShutterstockMaintenanceAlert);

exports.default = _default;
module.exports = exports.default;